import React from "react";
import { ScopedCssBaseline, ThemeProvider } from "@mui/material";
import { alphaSearchTheme } from "../theme";

/** Auth and onboarding stay light until their dark designs are available. */
export default function LightOnlyPage({ children, ...props }) {
  return (
    <ThemeProvider theme={alphaSearchTheme}>
      <ScopedCssBaseline enableColorScheme {...props}>
        {children}
      </ScopedCssBaseline>
    </ThemeProvider>
  );
}
